import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchCasinoProvidersReport } from "./casinoProvidersReportApi";

const queryKeyBase = ["casino", "providersReport"];

/**
 * @param {Object} params
 * @param {string|undefined} params.start_date
 * @param {string|undefined} params.end_date
 * @param {number|undefined} [params.page]
 * @param {number|undefined} [params.size]
 * @param {string|undefined} [params.search]
 * @param {string|undefined} [params.sort] API `sort` query (from `buildCasinoProvidersSortParam`)
 * @param {string[]|undefined} [params.money_type]
 * @param {Object} [options]
 * @param {boolean} [options.enabled]
 */
export function useCasinoProvidersReport(params, options = {}) {
  const {
    start_date,
    end_date,
    page = 1,
    size = 20,
    search,
    sort,
    money_type,
  } = params;
  const moneyTypeKey = money_type?.join(",") ?? "";

  return useQuery({
    queryKey: [
      ...queryKeyBase,
      start_date,
      end_date,
      page,
      size,
      search,
      sort ?? null,
      moneyTypeKey,
    ],
    queryFn: () =>
      fetchCasinoProvidersReport({
        start_date,
        end_date,
        page,
        size,
        search,
        money_type,
        ...(typeof sort === "string" && sort.trim() !== ""
          ? { sort: sort.trim() }
          : {}),
      }),
    enabled: options.enabled !== false && Boolean(start_date && end_date),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
}
